import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  type OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductQueryType } from '@models/product.model';
import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import { CarouselProductItemSkeletonComponent } from '../carousel-product-item-skeleton/carousel-product-item-skeleton.component';

@Component({
  selector: 'market-carousel-product-skeleton',
  standalone: true,
  imports: [CarouselProductItemSkeletonComponent, RouterModule],
  templateUrl: './carousel-product-skeleton.component.html',
  styleUrl: './carousel-product-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselProductSkeletonComponent implements OnInit, AfterViewInit {
  @Input() title: string = '';
  @Input() queryType = ProductQueryType.all;
  @ViewChild('splide') splide!: ElementRef<HTMLElement>;
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    new Splide(this.splide.nativeElement, {
      type: 'loop',
      grid: {
        rows: 2,
        cols: 2,
        gap: {
          row: '0.5rem',
          col: '0.5rem',
        },
      },
      arrows: false,
      pagination: false,
    }).mount({ Grid });
  }
}
